<template>
  <div>
    <div
      class="">
      <jFloatingPrompt ref="flowFloating">
        <h2 class="inline--block">
          {{ flow.name }} -
          {{ flow.type_name === 'ORDER'? 'IN':'' }}
          {{ flow.type_name }}
          {{ flow.minimum_action !== 0 ? flow.minimum_action : '' }}
        </h2>

        <!-- button UPDATE or DELETE -->
        <div class="wrap-button-flow">
          <b-button
            class="btn border white m__r--10 btn-secondary"
            @click="UpdateFlow">
            EDIT
          </b-button>
          <b-button
            class="btn red btn-secondary"
            @click="flowDeleted">
            DELETE
          </b-button>
          <i
            class="fa fa-times"
            @click="hideFlowFloating"/>
        </div>

        <!-- flow detail -->
        <div class="overflow-scroll">
          <div v-if="flow.use_division_chart === false">
            <div class="inline--block bullet">
              <div class="flow-new__bullet-top">
                <i class="fa fa-square"/>
              </div>
            </div>
            <div
              v-for="(approver, index) in flow.members"
              :key="index"
              class="approver-order inline--block">

              <div class="inline--block line-wrap">
                <div class="line-horizontal"/>
              </div>

              <div class="inline--block box-flow">
                <div class="header-flow">
                  <!-- <div class="header-actions">
                    <i
                      class="fa fa-edit"/>
                    <i
                      class="fa fa-times"/>
                  </div> -->
                  Approver {{ approver.order }}
                </div>
                <div class="content-flow">
                  {{ approver.organigram.name }} <br>
                  {{ approver.organigram_member_name ? approver.organigram_member_name : "" }}
                </div>
              </div>

            </div>
          </div>
        </div>

      </jFloatingPrompt>
    </div>
  </div>
</template>

<script>
// import { mapState } from 'vuex';
import jFloatingPrompt from '@/components/new-floating-templete/jFloatingPrompt';

export default {
  components: { jFloatingPrompt },
  props: {
    flow: {
      type: Object,
      default: null,
    },
  },
  computed: {
    // ...mapState('jFlows', ['manage_sla']),
  },
  watch: {
    // eslint-disable-next-line
    // 'manage_sla.is_open': function() {
    //   this.hideFlowFloating();
    // },
  },
  methods: {
    showFloatingDelete() {
      this.$refs.deleteFlow.show();
    },
    hideFloatingDelete() {
      this.$refs.deleteFlow.hide();
    },
    UpdateFlow() {
      if (this.flow.use_division_chart === false) {
        this.$router.replace(`/flow/update/${this.flow.id}`);
      } else {
        this.$router.replace(`/flow/update-by-division/${this.flow.id}`);
      }
    },
    flowDeleted() {
      // this.$refs.deleteFlow.hide();
      const text = `You want to delete "${this.flow.name}"`;

      this.$swal({
        title: 'Are you sure?',
        text,
        type: 'question',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.value) {
          this.$emit('deleteFlow');
        }
      });
    },
    hideFlowFloating() {
      this.$refs.flowFloating.hide();
      this.$emit('hideFloatingPrompt');
      this.$store.commit('jStoreFlows/setOpenFlow');
      this.$store.commit('jStoreFlows/setFlowData', null);
    },
  },
};
</script>

<style lang="scss" scoped>
.delete-flow {
  color: #42a5ce;
  cursor: pointer;
  position: absolute;
  right: 20px;
  top: 16px;
  .wrap-button-flow {
    position: relative;
    .btn {
      margin-left: 20px;
    }
  }
  .close-modal-flow {
    color: #42a5ce;
    cursor: pointer;
    font-size: 25px;
    position: absolute;
    right: 20px;
    top: 16px;
  }
  .title-flow {
    color: black;
    margin-bottom: 20px;
  }
  .modal-body {
    padding-bottom: 0px;
  }
}
.jFlow.flow-flex-center .wrap-button-flow .btn {
  margin-left: 20px;
}
h3 {
  text-align: center;
}
.mod-form .modal-body {
  padding-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/flow-rule/flow/flow-non-sla/jFlowFloatingPrompt.vue